export let MoghavematConfig: any = {
    headers: {
        'Access-Key': 'sAcheLr8aIvFyd0taqvOgReAzN9Be1d1y0s',
    }
};